/**
 * @author gll
 * 模块说明：退货单
 */
import { Service } from '@/tools'

export class RequireExternalService<T extends TProcure.RequireExternal> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.RequireExternal}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：新品添加前数据校验
   * /api/procure/require/external/v1/addCommodityValidate
   */
  addCommodityValidate = <K extends T['ApiAddCommodityValidate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddCommodityValidate', data)
}

